import { memo } from 'react';

import { usePlayerStore } from '@air/component-player';

import { getCommentRangePercentStyle } from '~/components/v2/components/asset-modal/visualizer/video/getCommentRangePercentStyle';
import { PLAYBACK_PROGRESS_MIN_WIDTH_PX } from '~/components/v2/components/asset-modal/visualizer/video/VideoCommentRangeSelector/constants';

type RangePlaybackProgressBarProps = {
  'data-testid': string;
  endTime: number;
  startTime: number;
};

export const RangePlaybackProgressBar = memo(
  ({ 'data-testid': dataTestId, endTime, startTime }: RangePlaybackProgressBarProps) => {
    const currentTime = usePlayerStore((state) => state.currentTime);
    const duration = usePlayerStore((state) => state.duration);

    if (duration <= 0 || startTime === endTime) {
      return null;
    }

    const rangeStartTime = Math.min(startTime, endTime);
    const rangeEndTime = Math.max(startTime, endTime);

    if (currentTime < rangeStartTime || currentTime > rangeEndTime) {
      return null;
    }

    return (
      <div
        className="pointer-events-none absolute bottom-0 h-1 rounded-4 ads:bg-primary bg-blue-9"
        data-testid={dataTestId}
        style={getCommentRangePercentStyle(
          { startTime: rangeStartTime, endTime: currentTime },
          duration,
          PLAYBACK_PROGRESS_MIN_WIDTH_PX,
        )}
      />
    );
  },
);

RangePlaybackProgressBar.displayName = 'RangePlaybackProgressBar';
